<template>
  <div>
    <div v-if="minWidth > 500" class="h-i-2">
      <div class="our-strength">
        <!-- 第一节 -->
        <div class="our-1">
          <div class="our-left">
            <div class="first-1">Strength</div>
            <div class="first-2">我们的实力</div>
            <div class="first-3">多项国家认证资质提供服务保障 </div>
            <div class="first-4" @click="demand">了解更多</div>
          </div>
          <div class="our-right">
            <div class="right-1">
              A number of national certification qualifications
              <br>
              provide service guarantee
            </div>
            <div class="right-2">
              <div class="r-i"
                v-for="(item, index) in tabIntroduce"
                :key="index"
                :class="item.id === tab ? 'active' : ''"
                @click="tabInclude(item)"
              >
                <div class="r-i-i">
                  <div class="icon">
                    <img :style='{
                      width: item.width,
                      height: item.height
                    }' :src="item.icon" alt="">
                  </div>
                  <div class="title">{{item.title}}</div>
                  <div class="content">{{item.content}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 第二节 -->
        <div class="our-2">
          <div class="out-1">Qualification</div>
          <div class="out-2">资质认证</div>
          <div class="out-3">多项国家认证资质</div>
          <div class="out-4">
            <img src="../assets/img/home/zz1.jpg" alt="">
            <img src="../assets/img/home/zz2.png" alt="">
          </div>
          <div class="out-5">
            <div class="o-5-l">
              <img :src="lance" alt="">
            </div>
            <div class="o-5-r">
              <div v-for="(item, i) in tabList" :key="i" @click="tabItemList(item)">
                <!-- <div class="order">
                  <img v-if="item.id == 1" :src="item.icon" alt="">
                </div> -->
                <div class="order" style="margin-left: 35px;">
                  <img v-if="item.id == 1" :src="item.icon" alt="">
                </div>
                <div class="order" style="margin-left: -170px;">
                  <img v-if="item.id != 1" :src="item.icon" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 第三节 -->
        <div class="our-3">
          <div class="o-3-l">
            <div class="zqq">
              <img src="../assets/img/home/zqq.png" alt="">
            </div>
            <div class="defi">
              <img src="../assets/img/solution/defi.png" alt="">
              <div class="d-content">Defi</div>
            </div>
            <div class="qb">
              <img src="../assets/img/solution/qb.png" alt="">
              <div class="d-content">分布式钱包</div>
            </div>
            <div class="jy">
              <img src="../assets/img/solution/jy.png" alt="">
              <div class="d-content">交易平台</div>
            </div>
            <div class="dapp">
              <img src="../assets/img/solution/dapp.png" alt="">
              <div class="d-content">DAPP</div>
            </div>
            <div class="gl">
              <img src="../assets/img/solution/gl.png" alt="">
              <div class="d-content">公链</div>
            </div>
            <div class="lh">
              <img src="../assets/img/solution/lh.png" alt="">
              <div class="d-content">分布式量化</div>
            </div>
          </div>
          <div class="o-3-r">
            <div class="position-index">solution</div>
            <div class="o-r-1">分布式解决方案</div>
            <div class="o-r-2">在分布式领域，提供完善的整体解决方案</div>
            <div class="o-r-3" @click="demand">
              <span>获 取 方 案</span>
              <img src="../assets/img/solution/arrows.png" alt="">
            </div>
          </div>
        </div>
        <!-- 第四节 -->
        <div class="our-4">
          <div class="o-3-r">
            <div class="p-solution">
              solution
            </div>
            <div class="o-r-1">数据系统解决方案</div>
            <div class="o-r-2">提供数据类系统应用服务,可定制化方案</div>
            <div class="o-r-3" @click="demand">
              <span>获 取 方 案</span>
              <img src="../assets/img/solution/arrows.png" alt="">
            </div>
          </div>
          <div class="o-3-l">
            <div class="zqq">
              <img src="../assets/img/home/zq.png" alt="">
            </div>
            <div class="defi">
              <img src="../assets/img/solution/wkdp.png" alt="">
              <div class="d-content">数据大屏</div>
            </div>
            <div class="qb">
              <img src="../assets/img/solution/sjksh.png" alt="">
              <div class="d-content">数据可视化</div>
            </div>
            <div class="jy">
              <img src="../assets/img/solution/sjyyxt.png" alt="">
              <div class="d-content">数据应用系统</div>
            </div>
            <div class="dapp">
              <img src="../assets/img/solution/wlwsj.png" alt="">
              <div class="d-content">物联网数据</div>
            </div>
            <div class="gl">
              <img src="../assets/img/solution/sjzw.png" alt="">
              <div class="d-content">数据政务</div>
            </div>
            <div class="lh">
              <img src="../assets/img/solution/qt.png" alt="">
              <div class="d-content">其他</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="minWidth < 500" class="strength-our-1">
      <div class="str-out">
        <div class="s-o-1">Strength</div>
        <div class="s-o-2">我们的实力</div>
        <div class="s-o-3">多项国家认证资质提供服务保障</div>
        <div class="s-o-4">
          A number of national certification qualifications<br>provide service guarantee
        </div>
        <div class="s-o-5">
          <div class="s-o-l">
            <img src="../assets/app/sl1.png" alt="">
            <div class="s-l">
              <p>国家资质认证</p>
              <div class="content">国家高新技术企业、双软认证企业，同时拥有超20项国家知识产权及相关资质</div>
            </div>
          </div>
          <div class="s-o-r">
            <div class="s-l">
              <p>一站式省心服务</p>
              <div class="content">APP、公众号、小程序、软件系统、营销推广、技术运维一站式服务</div>
            </div>
            <img src="../assets/app/sl2.png" alt="">
          </div>
          <div class="s-o-l-1">
            <img src="../assets/app/sl3.png" alt="">
            <div class="s-l">
              <p>技术架构能力</p>
              <div class="content">超过80人实力团队，8年行业经验，千万级商业系统架构能力</div>
            </div>
          </div>
          <div class="s-o-r-1">
            <div class="s-l">
              <p>严控项目流程</p>
              <div class="content">每个项目分7个阶段，9个开发团队角色、9项交付成果，严控进度和代码质量</div>
            </div>
            <img src="../assets/app/sl4.png" alt="">
          </div>
          <div class="s-o-l-i">
            <img src="../assets/app/sl5.png" alt="">
            <div class="s-l">
              <p>交付质量高</p>
              <div class="content">敏捷开发模式，全开源代码交付，有文档、有运维保障，迭代快 </div>
            </div>
          </div>
        </div>
        <div class="s-o-6" @click="demand">了解更多</div>
        <div class="s-o-1">Qualification</div>
        <div class="s-o-2">资质认证</div>
        <div class="s-o-3">多项国家认证资质</div>
        <div class="s-o-7">
          <img src="../assets/img/home/zz1.jpg" alt="">
          <img src="../assets/img/home/zz2.png" alt="">
        </div>
        <div class="s-o-8">
          <div class="o-5-l">
            <img :src="lance" alt="">
          </div>
          <div class="o-5-r">
            <div v-for="(item, i) in tabList" :key="i" @click="tabItemList(item)">
              <!-- <div class="order">
                <img v-if="item.id == 1" :src="item.icon" alt="">
              </div> -->
              <div class="order" style="margin-left: 10px;">
                <img v-if="item.id == 1" :src="item.icon" alt="">
              </div>
              <div class="order" style="margin-left: -60px;">
                <img v-if="item.id != 1" :src="item.icon" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="s-o-9">
          <div class="o-3-r">
            <div class="position-index">solution</div>
            <div class="o-r-1">分布式解决方案</div>
            <div class="o-r-2">在分布式领域，提供完善的整体解决方案</div>
            <div class="o-r-3" @click="demand">
              <span>获取方案</span>
              <img src="../assets/img/solution/arrows.png" alt="">
            </div>
          </div>
          <div class="o-3-l">
            <div class="zqq">
              <img src="../assets/img/home/zqq.png" alt="">
            </div>
            <div class="defi">
              <img src="../assets/img/solution/defi.png" alt="">
              <div class="d-content">Defi</div>
            </div>
            <div class="qb">
              <img src="../assets/img/solution/qb.png" alt="">
              <div class="d-content">分布式钱包</div>
            </div>
            <div class="jy">
              <img src="../assets/img/solution/jy.png" alt="">
              <div class="d-content">交易平台</div>
            </div>
            <div class="dapp">
              <img src="../assets/img/solution/dapp.png" alt="">
              <div class="d-content">DAPP</div>
            </div>
            <div class="gl">
              <img src="../assets/img/solution/gl.png" alt="">
              <div class="d-content">公链</div>
            </div>
            <div class="lh">
              <img src="../assets/img/solution/lh.png" alt="">
              <div class="d-content">分布式量化</div>
            </div>
          </div>
        </div>
        <div class="s-o-10">
          <div class="o-3-r">
            <div class="p-solution">
              solution
            </div>
            <div class="o-r-1">数据系统解决方案</div>
            <div class="o-r-2">提供数据类系统应用服务,可定制化方案</div>
            <div class="o-r-3" @click="demand">
              <span>获 取 方 案</span>
              <img src="../assets/img/solution/arrows.png" alt="">
            </div>
          </div>
          <div class="o-3-l">
            <div class="zqq">
              <img src="../assets/img/home/zq.png" alt="">
            </div>
            <div class="defi">
              <img src="../assets/img/solution/wkdp.png" alt="">
              <div class="d-content">数据大屏</div>
            </div>
            <div class="qb">
              <img src="../assets/img/solution/sjksh.png" alt="">
              <div class="d-content">数据可视化</div>
            </div>
            <div class="jy">
              <img src="../assets/img/solution/sjyyxt.png" alt="">
              <div class="d-content">数据应用系统</div>
            </div>
            <div class="dapp">
              <img src="../assets/img/solution/wlwsj.png" alt="">
              <div class="d-content">物联网数据</div>
            </div>
            <div class="gl">
              <img src="../assets/img/solution/sjzw.png" alt="">
              <div class="d-content">数据政务</div>
            </div>
            <div class="lh">
              <img src="../assets/img/solution/qt.png" alt="">
              <div class="d-content">其他</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      tab: 1,
      tabIntroduce: [
        {
          id: 1,
          icon: require('../assets/img/home/tab1.png'),
          title: '国家资质认证',
          content: '国家高新技术企业、双软认证企业，同时拥有超20项国家知识产权及相关资质',
          width: '32px',
          height: '34px'
        },
        {
          id: 2,
          icon: require('../assets/img/home/tab2.png'),
          title: '一站式省心服务',
          content: 'APP、 公众号、 小程序、 软件系统、 营销推广、 技术运维一站式服务',
          width: '30px',
          height: '32px'
        },
        {
          id: 3,
          icon: require('../assets/img/home/tab3.png'),
          title: '技术架构能力',
          content: '超过80人实力团队，8年行业经验，千万级商业系统架构能力',
          width: '36px',
          height: '40px'
        },
        {
          id: 4,
          icon: require('../assets/img/home/tab4.png'),
          title: '严控项目流程',
          content: '每个项目分7个阶段，9个开发团队角色、9项交付成果，严控进度和代码质量',
          width: '34px',
          height: '30px'
        },
        {
          id: 5,
          icon: require('../assets/img/home/tab5.png'),
          title: '交付质量高',
          content: '敏捷开发模式，全开源代码交付，有文档、有运维保障，迭代快 ',
          width: '36px',
          height: '32px'
        }
      ],
      lance: require('../assets/img/tab/lance.jpg'),
      tabCut: 1,
      tabList: [
        {
          id: 1,
          icon: require('../assets/img/tab/t3.jpg')
        },
        {
          id: 2,
          icon: require('../assets/img/tab/t1.jpg'),
        },
        {
          id: 3,
          icon: require('../assets/img/tab/t2.jpg'),
        },
        {
          id: 4,
          icon: require('../assets/img/tab/t15.jpg'),
        },
        {
          id: 5,
          icon: require('../assets/img/tab/t4.jpg'),
        },
        {
          id: 6,
          icon: require('../assets/img/tab/t5.jpg'),
        },
        {
          id: 7,
          icon: require('../assets/img/tab/t6.jpg'),
        },
        {
          id: 8,
          icon: require('../assets/img/tab/t7.jpg'),
        },
        {
          id: 9,
          icon: require('../assets/img/tab/t8.jpg'),
        },
        {
          id: 10,
          icon: require('../assets/img/tab/t9.jpg'),
        },
        {
          id: 11,
          icon: require('../assets/img/tab/t10.jpg'),
        },
        {
          id: 12,
          icon: require('../assets/img/tab/t11.jpg'),
        },
        {
          id: 13,
          icon: require('../assets/img/tab/t12.jpg'),
        },
        {
          id: 14,
          icon: require('../assets/img/tab/t13.jpg'),
        },
        {
          id: 15,
          icon: require('../assets/img/tab/t14.jpg'),
        },
        // {
        //   id: 16,
        //   icon: require('../assets/img/tab/lance.jpg'),
        // }
      ],
      minWidth:''
    }
  },
  mounted() {
    window.addEventListener('resize', this.getWidth);
    this.getWidth()
  },
  methods: {
    tabInclude(item) {
      this.tab = item.id
    },
    tabItemList(item) { // 软著搞起
      console.log('搞起', item)
      // this.tabCut = item.id
      this.lance = item.icon
    },
     getWidth(){
      // this.height = window.innerWidth - 70 + 'px';
      this.minWidth = String(window.innerWidth)
      console.log('kkkk', this.minWidth)
    },
    demand() { // 跳转客服
      // window.open()
      KS.openChatWin()
    }
  },
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 500px) {
  .h-i-2 {
      width: 100%;
      padding-bottom: 50px;
      // overflow-x:auto;
      .our-strength {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        // 我们的实力
        .our-1 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 60px;
          .our-left {
            .first-1 {
              font-size: 68px;
              font-family: Source Han Sans CN;
              font-weight: 800;
              color: #0C1364;
              opacity: 0.2;
              -webkit-text-stroke: 1px #FFFFFF;
              text-stroke: 1px #FFFFFF;
              // padding-top: 100px;
              padding-left: 15px;
            }
            .first-2 {
              font-size: 60px;
              font-family: PingFang SC;
              font-weight: 600;
              color: #FFFFFF;
              margin-top: -90px;
              z-index: 999;
              opacity: 0.99;
            }
            .first-3 {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              opacity: 0.5;
              margin-top: 30px;
            }
            .first-4 {
              width: 210px;
              height: 72px;
              background: linear-gradient(39deg, #B6359C, #EF0A6A);
              border-radius: 36px;
              font-size: 24px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
              text-align: center;
              line-height: 72px;
              cursor: pointer;
              margin-top: 30px;
            }
          }
          .our-right {
            width: 73%;
            height: 380px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 48px;
            position: relative;
            .right-1 {
              font-size: 16px;
              font-family: Source Han Sans CN;
              font-weight: 300;
              // color: #ADE9FF;
              color: #ffffff;
              opacity: 0.3;
              line-height: 24px;
              // opacity: 0.5;
              text-align: right;
              position: absolute;
              right: 30px;
              top: 35px;
            }
            .right-2 {
              display: flex;
              justify-content: space-between;
              // align-items: center;
              margin-top: 160px;
              .r-i {
                width: 20%;
                // background: #FFFFFF;
                // height: 200px;
                display: flex;
                justify-content: space-around;
                cursor: pointer;
                height: 260px;
                // align-items: center;
                .r-i-i {
                  display: flex;
                  align-items: center;
                  flex-direction: column;
                  // justify-content: center;
                  width: 80%;
                  .icon {
                    width: 40px;
                    height: 40px;
                    img {
                      width: 32px;
                      height: 34px;
                    }
                  }
                  .title {
                    margin-top: 24px;
                    font-size: 18px;
                    color: #ffffff;
                  }
                  .content {
                    color: #556AD5;
                    font-size: 16px;
                    text-align: center;
                    margin-top: 10px;
                  }
                }
              }
              @keyframes fadeInBig{
                from{opacity: 0;transform: scale(2.5);}
                to{opacity: 1;transform: scale(1);}
              }
              // .r-i:hover {
                // animation: fadeInBig 1.5s 2s linear forwards;
                // -webkit-animation: fadeInBig 1.5s 2s linear forwards;
              // }
              .active {
                background: #ffffff;
                padding: 30px 0px;
                margin-top: -30px;
                border-radius: 24px;
                .r-i-i {
                  .title {
                    color: #000000;
                  }
                  .content {
                    color: #9391A6;
                  }
                }
              }
              // .r-i:first-child {
              //   background: #ffffff;
              //   padding: 30px 0px;
              //   margin-top: -30px;
              //   border-radius: 24px;
              //   .r-i-i {
              //     .title {
              //       color: #000000;
              //     }
              //     .content {
              //       color: #9391A6;
              //     }
              //   }
              // }
              .r-i:hover {
                background: #d3d5e3;
                padding: 30px 0px;
                margin-top: -30px;
                border-radius: 24px;
                .r-i-i {
                  .title {
                    color: #000000;
                  }
                  .content {
                    color: #ffffff;
                  }
                }
              }
            }
          }
        }
        .our-2 {
          .out-1 {
            font-size: 68px;
            font-family: Source Han Sans CN;
            font-weight: 800;
            color: #0C1364;
            opacity: 0.2;
            -webkit-text-stroke: 1px #FFFFFF;
            text-stroke: 1px #FFFFFF;
            // padding-top: 100px;
            margin-top: 120px;
            text-align: center;
          }
          .out-2 {
            font-size: 60px;
            font-family: PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            margin-top: -90px;
            z-index: 999;
            opacity: 0.9;
            text-align: center;
          }
          .out-3 {
            text-align: center;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 300;
            color: #FFFFFF;
            opacity: 0.5;
            margin-top: 10px;
          }
          .out-4 {
            margin-top: 30px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            img {
              width: 30%;
              height: 270px;
            }
          }
          .out-5 {
            margin-top: 80px;
            display: flex;
            justify-content: space-between;
            height: 290px;
            .o-5-l {
              img {}
                width: 18%;
                height: 290px;
              }
            cursor: pointer;
            .o-5-r {
              width: 80%;
              height: 100%;
              display: flex;
              .order {
                // width: 226px;
                img {
                  width: 226px;
                  height: 290px;
                }
              }
            }
          }
        }
        .our-3 {
          margin-top: 100px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          // @keyframes myMove1 {
          //     from {transform: rotate(0deg);}
          //     to {transform: rotate(360deg);}
          // }
          // @-webkit-keyframes myMove1 {
          //     from {transform: rotate(0deg);}
          //     to {transform: rotate(360deg);}
          // }
          @keyframes rotate {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
          // @keyframes rotate1 {
          //   from {
          //     transform: translate(-50%, -50%) rotate(0deg);
          //   }
          //   to {
          //     transform: translate(-50%, -50%) rotate(-360deg);
          //   }
          // }
          @keyframes rotate1 {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(-360deg);
            }
          }
          .o-3-l {
            width: 58%;
            height: 680px;
            // background: url(../assets/img/home/zqq.png) no-repeat;
            // background-size: 100% 100%;
            position: relative;
            // animation: rotate 15s linear infinite;
            // animation: myMove1 5s ease-in infinite alternate;
            // -webkit-animation: myMove1 5s ease-in infinite alternate;
            .zqq {
              animation: rotate 10s linear infinite;
            }
            .defi {
              display: flex;
              align-items: center;
              flex-direction: column;
              height: 100%;
              justify-content: center;
              margin-left: 50px;
              cursor: pointer;
              position: absolute;
              top: 0%;
              left: 39%;
              img {
                width: 130px;
                height: 90px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .qb {
              display: flex;
              align-items: center;
              flex-direction: column;
              position: absolute;
              top: 50px;
              left: 190px;
              cursor: pointer;
              img {
                width: 76px;
                height: 67px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .jy {
              display: flex;
              align-items: center;
              flex-direction: column;
              position: absolute;
              top: 0px;
              cursor: pointer;
              right: 190px;
              img {
                width: 80px;
                height: 80px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .dapp {
              display: flex;
              align-items: center;
              flex-direction: column;
              position: absolute;
              top: 350px;
              left: 100px;
              cursor: pointer;
              img {
                width: 80px;
                height: 80px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .gl {
              display: flex;
              align-items: center;
              flex-direction: column;
              position: absolute;
              top: 270px;
              cursor: pointer;
              right: 50px;
              img {
                width: 85px;
                height: 85px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .lh {
              display: flex;
              align-items: center;
              flex-direction: column;
              position: absolute;
              bottom: 70px;
              cursor: pointer;
              right: 200px;
              img {
                width: 97px;
                height: 97px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
          }
          .o-3-r {
            width: 40%;
            position: relative;
            .position-index {
              position: absolute;
              font-size: 180px;
              font-family: Source Han Sans CN;
              font-weight: 800;
              color: #0C1364;
              opacity: 0.3;
              right: 0px;
              top: -150px;
              -webkit-text-stroke: 1px #00CCFF;
              text-stroke: 1px #00CCFF;
            }
            .o-r-1 {
              font-size: 60px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
              opacity: 0.95;
            }
            .o-r-2 {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              opacity: 0.5;
              margin-top: 10px;
            }
            .o-r-3 {
              width: 380px;
              height: 72px;
              background: linear-gradient(73deg, #B6359C 0%, #EF0A6A 100%);
              border-radius: 36px;
              margin-top: 60px;
              display: flex;
              align-items: center;
              justify-content: space-around;
              cursor: pointer;
              span {
                font-size: 24px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
              }
              img {
                width: 67px;
                height: 17px;
              }
            }
          }
        }
        .our-4 {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .o-3-l {
            width: 60%;
            height: 680px;
            // background: url(../assets/img/home/zq.png) no-repeat;
            // background-size: 100% 100%;
            position: relative;
            .zqq {
              animation: rotate1 10s linear infinite;
            }
            .defi {
              display: flex;
              align-items: center;
              flex-direction: column;
              height: 100%;
              justify-content: center;
              cursor: pointer;
              // margin-left: 50px;
              position: absolute;
              top: 0%;
              right: 45%;
              img {
                width: 85px;
                height: 69px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .qb {
              display: flex;
              align-items: center;
              flex-direction: column;
              cursor: pointer;
              position: absolute;
              top: 50px;
              left: 150px;
              img {
                width: 82px;
                height: 82px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .jy {
              display: flex;
              align-items: center;
              flex-direction: column;
              position: absolute;
              cursor: pointer;
              top: 70px;
              right: 170px;
              img {
                width: 62px;
                height: 62px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .dapp {
              display: flex;
              align-items: center;
              flex-direction: column;
              position: absolute;
              top: 300px;
              cursor: pointer;
              left: 20px;
              img {
                width: 64px;
                height: 62px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .gl {
              display: flex;
              align-items: center;
              flex-direction: column;
              cursor: pointer;
              position: absolute;
              top: 350px;
              right: 100px;
              img {
                width: 63px;
                height: 62px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
            .lh {
              display: flex;
              align-items: center;
              flex-direction: column;
              position: absolute;
              bottom: 30px;
              right: 300px;
              cursor: pointer;
              img {
                width: 72px;
                height: 72px;
              }
              .d-content {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #FFFFFF;
                margin-top: 10px;
              }
            }
          }
          .o-3-r {
            width: 40%;
            position: relative;
            .p-solution {
              position: absolute;
              position: absolute;
              font-size: 180px;
              font-family: Source Han Sans CN;
              font-weight: 800;
              color: #0C1364;
              opacity: 0.3;
              left: 0px;
              top: -150px;
              -webkit-text-stroke: 1px #00CCFF;
              text-stroke: 1px #00CCFF;
            }
            .o-r-1 {
              opacity: 0.95;
              font-size: 60px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
            }
            .o-r-2 {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              opacity: 0.5;
              margin-top: 10px;
            }
            .o-r-3 {
              width: 380px;
              height: 72px;
              background: linear-gradient(73deg, #B6359C 0%, #EF0A6A 100%);
              border-radius: 36px;
              margin-top: 60px;
              display: flex;
              align-items: center;
              justify-content: space-around;
              cursor: pointer;
              span {
                font-size: 24px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
              }
              img {
                width: 67px;
                height: 17px;
              }
            }
          }
        }
      }
    }
}
@media screen and (min-width:359px) and (max-width: 500px) {
  .strength-our-1 {
    width: 100%;
    height: 100%;
    padding-bottom: 30px;
    .str-out {
      width: 90%;
      margin: 0 auto;
      .s-o-1 {
        font-size: 40px;
        font-family: Source Han Sans CN;
        font-weight: 800;
        color: #0C1364;
        opacity: 0.2;
        -webkit-text-stroke: 1px #FFFFFF;
        text-stroke: 1px #FFFFFF;
        text-align: center;
        margin-top: 40px;
      }
      .s-o-2 {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        text-align: center;
        margin-top: -50px;
        opacity: 0.98;
      }
      .s-o-3 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 300;
        color: #FFFFFF;
        opacity: 0.3;
        text-align: center;
        margin-top: 20px;
      }
      .s-o-4 {
        font-size: 11px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        color: #ADE9FF;
        line-height: 16px;
        opacity: 0.5;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        text-align: right;
        margin-top: 20px;
      }
      .s-o-5 {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .s-o-l {
          display: flex;
          width: 45%;
          margin-top: 20px;
          img {
            width: 21px;
            height: 22px;
          }
          .s-l {
            margin-left: 10px;
            p {
              color: #ffffff;
              font-size: 16px;
            }
            .content {
              color: #556AD5;
              width: 100%;
              font-size: 12px;
              margin-top: 6px;
            }
          }
        }
        .s-o-r {
          display: flex;
          width: 45%;
          margin-top: 20px;
          img {
            width: 20px;
            height: 21px;
            margin-left: 10px;
          }
          .s-l {
            // margin-left: 10px;
            p {
              color: #ffffff;
              font-size: 16px;
              text-align: right;
            }
            .content {
              color: #556AD5;
              width: 100%;
              font-size: 12px;
              margin-top: 6px;
              text-align: right;
            }
          }
        }
        .s-o-l-1 {
          display: flex;
          width: 45%;
          margin-top: 20px;
          img {
            width: 22px;
            height: 24px;
          }
          .s-l {
            margin-left: 10px;
            p {
              color: #ffffff;
              font-size: 16px;
            }
            .content {
              color: #556AD5;
              width: 100%;
              font-size: 12px;
              margin-top: 6px;
            }
          }
        }
        .s-o-r-1 {
          display: flex;
          width: 45%;
          margin-top: 20px;
          img {
            width: 23px;
            height: 20px;
            margin-left: 10px;
          }
          .s-l {
            // margin-left: 10px;
            p {
              color: #ffffff;
              font-size: 16px;
              text-align: right;
            }
            .content {
              color: #556AD5;
              width: 100%;
              font-size: 12px;
              margin-top: 6px;
              text-align: right;
            }
          }
        }
        .s-o-l-i {
          display: flex;
          margin-top: 20px;
          img {
            width: 21px;
            height: 19px;
          }
          .s-l {
            margin-left: 10px;
            p {
              color: #ffffff;
              font-size: 16px;
            }
            .content {
              color: #556AD5;
              font-size: 12px;
              margin-top: 6px;
            }
          }
        }
      }
      .s-o-6 {
        width: 40%;
        height: 36px;
        background: linear-gradient(39deg, #B6359C, #EF0A6A);
        border-radius: 18px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        margin-top: 20px;
      }
      .s-o-7 {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 20px;
        img {
          width: 40%;
          height: 95px;
        }
      }
      .s-o-8 {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        height: 110px;
        .o-5-l {
        width: 23%;
          img {
            width: 100%;
            height: 110px;
          }
        }
        cursor: pointer;
        .o-5-r {
          width: 73%;
          height: 100%;
          display: flex;
          .order {
            // width: 226px;
            img {
              width: 80px;
              height: 110px;
            }
          }
        }
      }
      .s-o-9 {
        width: 100%;
        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        @keyframes rotate1 {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(-360deg);
          }
        }
        .o-3-r {
          // position: relative;
          margin: 0 auto;
          margin-top: 60px;
          .position-index {
            // position: absolute;
            font-size: 60px;
            font-family: Source Han Sans CN;
            font-weight: 800;
            color: #0C1364;
            opacity: 0.3;
            -webkit-text-stroke: 1px #00CCFF;
            text-stroke: 1px #00CCFF;
            text-align: center;
          }
          .o-r-1 {
            font-size: 28px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            opacity: 0.95;
            text-align: center;
            margin-top: -55px;
          }
          .o-r-2 {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 300;
            color: #FFFFFF;
            opacity: 0.5;
            margin-top: 15px;
            text-align: center;
          }
          .o-r-3 {
            width: 50%;
            height: 36px;
            background: linear-gradient(73deg, #B6359C 0%, #EF0A6A 100%);
            border-radius: 18px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            cursor: pointer;
            margin: 0 auto;
            margin-top: 30px;
            span {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
            }
            img {
              width: 30px;
              height: 9px;
            }
          }
        }
        .o-3-l {
          width: 100%;
          // height: 200px;
          position: relative;
          margin-top: 30px;
          .zqq {
            margin: 0 auto;
            width: 100%;
            // animation: rotate 10s linear infinite;
          }
          .defi {
            display: flex;
            align-items: center;
            flex-direction: column;
            height: 100%;
            justify-content: center;
            margin-left: 50px;
            cursor: pointer;
            position: absolute;
            top: 0%;
            left: 33%;
            img {
              width: 60px;
              height: 43px;
            }
            .d-content {
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              margin-top: 5px;
              opacity: 0.4;
            }
          }
          .qb {
            display: flex;
            align-items: center;
            flex-direction: column;
            position: absolute;
            top: 9%;
            left: 25%;
            cursor: pointer;
            img {
              width: 33px;
              height: 30px;
            }
            .d-content {
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              margin-top: 5px;
              opacity: 0.4;
            }
          }
          .jy {
            display: flex;
            align-items: center;
            flex-direction: column;
            position: absolute;
            top: 3%;
            cursor: pointer;
            right: 18%;
            img {
              width: 36px;
              height: 36px;
            }
            .d-content {
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              margin-top: 5px;
              opacity: 0.4;
            }
          }
          .dapp {
            display: flex;
            align-items: center;
            flex-direction: column;
            position: absolute;
            top: 55%;
            left: 15%;
            cursor: pointer;
            img {
              width: 32px;
              height: 32px;
            }
            .d-content {
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              margin-top: 5px;
              opacity: 0.4;            }
          }
          .gl {
            display: flex;
            align-items: center;
            flex-direction: column;
            position: absolute;
            top: 38%;
            cursor: pointer;
            right: 5%;
            img {
              width: 36px;
              height: 36px;
            }
            .d-content {
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              margin-top: 5px;
              opacity: 0.4;
            }
          }
          .lh {
            display: flex;
            align-items: center;
            flex-direction: column;
            position: absolute;
            bottom: 8%;
            cursor: pointer;
            right: 32%;
            img {
              width: 40px;
              height: 40px;
            }
            .d-content {
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              margin-top: 5px;
              opacity: 0.4;
            }
          }
        }
      }
      .s-o-10 {
        width: 100%;
        // margin-top: 20px;
        .o-3-l {
          width: 100%;
          margin-top: 20px;
          position: relative;
          .zqq {
            width: 100%;
            margin: 0 auto;
            // animation: rotate1 10s linear infinite;
          }
          .defi {
            display: flex;
            align-items: center;
            flex-direction: column;
            height: 100%;
            justify-content: center;
            cursor: pointer;
            // margin-left: 50px;
            position: absolute;
            top: 0%;
            right: 45%;
            img {
              width: 40px;
              height: 32px;
            }
            .d-content {
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              margin-top: 5px;
              opacity: 0.4;
            }
          }
          .qb {
            display: flex;
            align-items: center;
            flex-direction: column;
            cursor: pointer;
            position: absolute;
            top: 10%;
            left: 15%;
            img {
              width: 40px;
              height: 40px;
            }
            .d-content {
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              margin-top: 5px;
              opacity: 0.4;
            }
          }
          .jy {
            display: flex;
            align-items: center;
            flex-direction: column;
            position: absolute;
            cursor: pointer;
            top: 12%;
            right: 20%;
            img {
              width: 30px;
              height: 30px;
            }
            .d-content {
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              margin-top: 5px;
              opacity: 0.4;
            }
          }
          .dapp {
            display: flex;
            align-items: center;
            flex-direction: column;
            position: absolute;
            top: 50%;
            cursor: pointer;
            left: 3%;
            img {
              width: 31px;
              height: 29px;
            }
            .d-content {
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              margin-top: 5px;
              opacity: 0.4;
            }
          }
          .gl {
            display: flex;
            align-items: center;
            flex-direction: column;
            cursor: pointer;
            position: absolute;
            top: 55%;
            right: 15%;
            img {
              width: 30px;
              height: 29px;
            }
            .d-content {
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              margin-top: 5px;
              opacity: 0.4;
            }
          }
          .lh {
            display: flex;
            align-items: center;
            flex-direction: column;
            position: absolute;
            bottom: 3%;
            right: 43%;
            cursor: pointer;
            img {
              width: 34px;
              height: 34px;
            }
            .d-content {
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              margin-top: 5px;
              opacity: 0.4;
            }
          }
        }
        .o-3-r {
          margin: 0 auto;
          margin-top: 30px;
          .p-solution {
            // position: absolute;
            font-size: 60px;
            font-family: Source Han Sans CN;
            font-weight: 800;
            color: #0C1364;
            opacity: 0.3;
            -webkit-text-stroke: 1px #00CCFF;
            text-stroke: 1px #00CCFF;
            text-align: center;
          }
          .o-r-1 {
            font-size: 28px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            opacity: 0.95;
            text-align: center;
            margin-top: -55px;
          }
          .o-r-2 {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 300;
            color: #FFFFFF;
            opacity: 0.5;
            margin-top: 15px;
            text-align: center;
          }
          .o-r-3 {
            width: 50%;
            height: 36px;
            background: linear-gradient(73deg, #B6359C 0%, #EF0A6A 100%);
            border-radius: 18px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            cursor: pointer;
            margin: 0 auto;
            margin-top: 30px;
            span {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
            }
            img {
              width: 30px;
              height: 9px;
            }
          }
        }
      }
    }
  }
}
</style>
